
import { BackgroundIcon, Card, Header, IconWrapper, Title, Value } from "./styled";

export interface MetricCardProps {
  title: string;
  value: string | number;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
  trend?: number;
  className?: string;
  delay?: number;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  className,
  delay = 0,
}) => {
  //const getTrendType = (): "up" | "down" | "neutral" => {
    //if (trend && trend > 0) return "up";
    //if (trend && trend < 0) return "down";
    //return "neutral";
  //};

  return (
    <Card
      className={className}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
    >
      {Icon && (
        <BackgroundIcon>
          <Icon size={64} />
        </BackgroundIcon>
      )}

      <Header>
        <Title>{title}</Title>
        {Icon && (
          <IconWrapper>
            <Icon size={20} />
          </IconWrapper>
        )}
      </Header>

      <Value>{value}</Value>

    </Card>
  );
};

export default MetricCard;